import React, { useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";

import { Dropdown } from "react-bootstrap";

// Componentes react-bootstrap
import { Container, Button, Modal, Row, Form, Col } from "react-bootstrap";
import Load from "../../common/Load";

// helpers
import { iniciarSesion } from "../../../helpers/iniciarSesion";

// encode64
import encode64 from "../../../helpers/encode64";

// router
import { useNavigate } from "react-router-dom";

// services
import { mapgisSeg } from "../../../services/mapgisSeg";

export default function LoginModal({ idComponente }) {
  // // navigate
  const navigate = useNavigate();

  // Load
  const [load, setLoad] = useState(false);

  // state modal
  const [stateShowLogin, setShowLogin] = useState(false);

  // state opciones login
  const [optLogin, setOptLogin] = useState(false);

  // State data login User
  const [dataUserLogin, setDataUserLogin] = useState({
    userName: "",
    password: "",
    idApp: process.env.REACT_APP_ID_APP,
  });

  // user
  const [user, setUser] = useState(null);

  // Abrir modal
  const handleShowLogin = () => setShowLogin(true);

  // Cerrar modal
  const handleCloseLogin = () => {
    setShowLogin(false);
  };

  const handleChangeLogin = ({ target }) => {
    setDataUserLogin({
      ...dataUserLogin,
      [target.name]: encode64(target.value),
    });
  };

  const consultarToken = async () => {
    const responseToken = await mapgisSeg("validacionToken.do", {
      app: process.env.REACT_APP_ID_APP,
    });

    return responseToken;
  };

  const decodeToken = async (token = null) => {
    try {
      if (!token) {
        const responseToken = await consultarToken();
        if (responseToken !== "Sin autenticacion") {
          const responseDecodeJwt = await mapgisSeg("validarToken.do", {
            token: responseToken,
          });
          if (responseDecodeJwt.identificador !== "Publico") {
            setUser(responseDecodeJwt.strIdentificador);
            localStorage.setItem("superAdmin", true);
            localStorage.setItem("usuarioPublico", false);
          } else {
            setUser(null);
            localStorage.setItem("superAdmin", false);
            localStorage.setItem("usuarioPublico", true);
          }
        } else {
          setUser(null);
          localStorage.setItem("superAdmin", false);
          localStorage.setItem("usuarioPublico", true);
        }
      } else {
        const responseDecodeJwt = await mapgisSeg("validarToken.do", {
          token,
        });

        localStorage.setItem("superAdmin", true);
        localStorage.setItem("usuarioPublico", false);
        setUser(responseDecodeJwt.strIdentificador);
      }
    } catch (err) {
      setUser(null);
      localStorage.setItem("superAdmin", false);
      localStorage.setItem("usuarioPublico", true);
      return false;
    }
  };

  const iniciarSesionLogin = async () => {
    setLoad(true);
    try {
      if (!dataUserLogin.userName || !dataUserLogin.password) {
        alert("Campos obligatorios, por favor digite un valor");
        return;
      }

      const responseLogin = await iniciarSesion(dataUserLogin);

      if (responseLogin.login) {
        const token = await consultarToken();

        if (token !== "Sin autenticacion") {
          // Activar intervalo para validar session
          const identificadorIntervalo = setInterval(async () => {
            const responseSession = await mapgisSeg("ValidarSessionMapgis.do", {
              app: process.env.REACT_APP_ID_APP,
            });

            if (responseSession === 0) {
              clearInterval(identificadorIntervalo);
            }
          }, 1200000);

          await decodeToken(token);

          handleCloseLogin();

          localStorage.setItem("superAdmin", true);
          localStorage.setItem("usuarioPublico", false);
          reloadPage();
        } else {
          alert("Sin autentificacion");
        }
      } else {
        alert("usuario o contraseña invalidos");
      }
    } catch (err) {
      alert("Error al iniciar sesión.");
    } finally {
      setLoad(false);
    }
  };

  const reloadPage = () => {
    navigate("/", { replace: true });
    window.listarAtributos();
    window.respPath();
  };

  const cerrarSesion = async () => {
    try {
      await mapgisSeg("cerrarSession.do", {
        app: process.env.REACT_APP_ID_APP,
      });
      setUser(null);
      setOptLogin(false);
      localStorage.setItem("superAdmin", false);
      reloadPage();
    } catch (error) {
      alert("Error al iniciar sesion");
    }
  };

  const validarSessionInitApp = async () => {
    try {
      const token = await consultarToken();
      if (token !== "Sin autenticacion") {
        const identificadorInterval = setInterval(async () => {
          const responseSession = await mapgisSeg("ValidarSessionMapgis.do", {
            app: process.env.REACT_APP_ID_APP,
          });

          if (responseSession === 0) {
            clearInterval(identificadorInterval);
          }
        }, 1200000);
      }
    } catch (err) {
      return false;
    }
  };

  useEffect(() => {
    decodeToken();
  }, [idComponente]);

  useEffect(() => {
    validarSessionInitApp();
  }, []);

  return (
    <>
      <button
        className="delete-efectobotones"
        id="user-or_initSesion"
        onClick={() => {
          user ? setOptLogin(!optLogin) : handleShowLogin();
        }}
        // onBlur={() => user && setOptLogin(false)}
      >
        <i className={user ? "icon-sesion" : "hide"}></i>
        {user ? user : "Inicio de sesión"}
      </button>
      <i className={user ? "cerrarsesion cursor-pointer" : "hide"} />
      <div
        className="modal-session"
        style={{ display: optLogin ? "block" && "flex" : "none" }}
      >
        <ul className="list-session">
          <a
            onClick={() => cerrarSesion()}
            className="li-nodecaration li-decorate decoration-none decoration-none"
            href="##"
          >
            Salir
          </a>
        </ul>
      </div>
      <Modal
        show={stateShowLogin}
        onHide={handleCloseLogin}
        scrollable={true}
        size="md"
        id="modalLogin"
      >
        <Modal.Header closeButton>
          <Modal.Title>Ingresa tus datos para iniciar sesíon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="pb-2">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-login">
                    Ingresa el usuario
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="userName"
                    onChange={handleChangeLogin}
                    className="inputs-forms-login focus-login"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-login">
                    Digita la contraseña
                  </Form.Label>
                  <Form.Control
                    type="password"
                    id="password"
                    name="password"
                    onChange={handleChangeLogin}
                    className="inputs-forms-login focus-login"
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="container-accion-login m-3">
              <Button
                className="btn-geomedellin btn-register-login btn-accion"
                onClick={iniciarSesionLogin}
              >
                Ingresar
              </Button>
            </div>
            <div className="container-accion-login mt-4">
              <p className="reset-pasword-login">
                ¿Olvidó su contraseña?
                <a
                  href="https://www.medellin.gov.co/registrate#modu_lof_reg_"
                  className="reset-password-a"
                  target="_blank"
                  rel="noreferrer"
                >
                  Recupérala aquí
                </a>
              </p>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
      <Load visible={load} />
    </>
  );
}
